import {
  CognitoIdentityProviderClient,
  ConfirmSignUpCommand,
  ResendConfirmationCodeCommand,
} from "@aws-sdk/client-cognito-identity-provider";

const region = "us-west-2"; // Consider making this configurable
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const debug = urlParams.get("debug") ?? "";

export const cognitoConfirmSignUp = async (
  clientId,
  confirmationCode,
  username
) => {
  if (debug) {
    console.debug(
      "cognitoConfirmSignUp:",
      JSON.stringify({ clientId, confirmationCode, username })
    );
  }
  const client = new CognitoIdentityProviderClient({ region });
  const params = {
    ClientId: clientId,
    ConfirmationCode: confirmationCode,
    Username: username,
  };
  const command = new ConfirmSignUpCommand(params);
  const result = await client.send(command);
  if (debug) {
    console.debug("cognitoConfirmSignUp result:", JSON.stringify(result));
  }
  return result;
};

export const cognitoResendConfirmationCode = async (clientId, username) => {
  if (debug) {
    console.debug(
      "cognitoResendConfirmationCode:",
      JSON.stringify({ clientId, username })
    );
  }
  const client = new CognitoIdentityProviderClient({ region });
  const command = new ResendConfirmationCodeCommand({
    ClientId: clientId,
    Username: username,
  });
  const result = await client.send(command);
  if (debug) {
    console.debug("cognitoResendConfirmationCode result:", JSON.stringify(result));
  }
  return result;
};
